export enum IntegrationServices {
  GOOGLE = 'Google Workspace',
  JIRA = 'Jira',
  TEMPO = 'Tempo',
  QUICKBOOKS = 'Quickbooks',
  SLACK = 'Slack',
  NOTION = 'Notion',
  CLOCKIFY = 'Clockify',
  ZOHO_PEOPLE = 'Zoho People',
  BAMBOOHR = 'BambooHR',
}

export enum IntegrationState {
  NOT_CONNECTED = 'not_connected',
  SYNCING = 'syncing',
  CONNECTED = 'connected',
  ERROR_CONNECTION = 'error_connection',
}

export enum IntegrationDataType {
  TEAM_MEMBER = 'TEAM_MEMBER',
  PROJECT = 'PROJECT',
  CLIENT = 'CLIENT',
  ASSIGNMENT = 'ASSIGNMENT',
  TIME_LOG = 'TIME_LOG',
  FINANCE = 'FINANCE',
  TIME_OFF = 'TIME_OFF',
}

export interface Integration {
  service: IntegrationServices;
  dataTypes: IntegrationDataType[];
  state: IntegrationState;
  lastSyncedAt?: Date;
}
